import { BusinessKeywordsMapping } from 'api/client/mapping/business-keywords-mapping';
import { GeneralKeywordsApi } from 'api/general-keywords';
import { AccommodationTypesClient, AirlinesClient, ApprovalLevelsClient, CountriesClient, DeviationTeamsClient, IMapZoneInfoDTO, ISiteInfoDTO, MapZonesClient, OrganisationEntitiesClient, SitesClient, TransportationTypesClient, TravelTypesClient } from 'api/swagger/ApiClient';
import { autoinject } from "aurelia-framework";
import { AccommodationType, Airline, ApprovalLevel, Country, DeviationTeam, OrganisationEntity, Site, TransportType, TravelType } from 'model/business-keywords';
import { DeviationTeamsMapping } from './mapping/deviation-teams-mapping';
import { EssentialTypesMapping } from './mapping/essential-types-mapping';

@autoinject
export class GeneralKeywordsClientApi implements GeneralKeywordsApi {
  constructor(private transportationTypesClient: TransportationTypesClient, private accommodationTypesClient: AccommodationTypesClient, private countriesClient: CountriesClient, private deviationTeamsClient: DeviationTeamsClient,
    private airlinesClient: AirlinesClient, private approvalLevelsClient: ApprovalLevelsClient, private organisationEntitiesClient: OrganisationEntitiesClient, private travelTypesClient: TravelTypesClient, private businessKeywordsMapping: BusinessKeywordsMapping,
    private essentialTypesMapping: EssentialTypesMapping, private deviationTeamsMapping: DeviationTeamsMapping, private mapZonesClient: MapZonesClient, private sitesClient: SitesClient) { }

  async getTransportTypes(): Promise<TransportType[]> {
    return (await this.transportationTypesClient.getAllActiveKeywords()).map(x => this.businessKeywordsMapping.mapToTransportType(x));
  }

  async getAccommodationTypes(): Promise<AccommodationType[]> {
    return (await this.accommodationTypesClient.getAllActiveKeywords()).map(x => this.businessKeywordsMapping.mapToAccommodationType(x));
  }

  async getCountries(): Promise<Country[]> {
    return (await this.countriesClient.getAllActiveKeywords()).map(x => this.businessKeywordsMapping.mapToCountry(x));
  }

  async getAirlines(): Promise<Airline[]> {
    return (await this.airlinesClient.getAllActiveKeywords()).map(x => this.businessKeywordsMapping.mapToAirline(x));
  }

  async getApprovalLevels(): Promise<ApprovalLevel[]> {
    return (await this.approvalLevelsClient.getAllActiveKeywords()).map(x => this.businessKeywordsMapping.mapToApprovalLevel(x));
  }

  async getOrganisationEntities(): Promise<OrganisationEntity[]> {
    return this.organisationEntitiesClient.getAllActiveKeywords();
  }

  async getTravelTypes(): Promise<TravelType[]> {
    return this.travelTypesClient.getAllActiveKeywords();
  }

  async getDeviationTeams(): Promise<DeviationTeam[]> {
    return (await this.deviationTeamsClient.getKeywords()).map(x => this.deviationTeamsMapping.mapToDeviationTeam(x));
  }

  async getMapZones(): Promise<IMapZoneInfoDTO[]> {
    return (await this.mapZonesClient.getAllActiveKeywords());
  }

  async getSites(countries: Country[]): Promise<Site[]> {
    return (await this.sitesClient.getAllActiveKeywords())
      .map(x => {
        return {
          id: x.id,
          name: x.name,
          address: x.address,
          country: countries.find(c => c.id === x.countryId),
          assetType: x.assetType,
          operation: x.operation,
          latitude: x.latitude,
          longitude: x.longitude,
          icon: x.siteType.icon
        } as Site
      });
  }
}
